<template>
    <!--  BEGIN SIDEBAR  -->
    <div class='sidebar-wrapper sidebar-theme'>
        <nav ref='menu' id='sidebar'>
            <div class='shadow-bottom'></div>

            <perfect-scrollbar
                class='list-unstyled menu-categories'
                tag='ul'
                :options='{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }'>

<!--                <li class='menu'>-->
<!--                    <router-link :to='{name: "home"}' class='dropdown-toggle' @click='toggleMobileMenu'>-->
<!--                        <div class=''>-->
<!--                            <font-awesome-icon icon='fa-solid fa-chart-pie' />-->
<!--                            <span>Dashboard</span>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </li>-->

                <li class='menu'>
                    <router-link :to='{name: "proposal"}' class='dropdown-toggle' @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-handshake-simple' />
                            <span>Propostas</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu'>
                    <router-link :to='{name: "contract"}' class='dropdown-toggle' @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-file-contract' />
                            <span>Contratos</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu'>
                    <router-link :to='{name: "calculate"}' class='dropdown-toggle' @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-calculator' />
                            <span>Calculadora</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu'>
                    <router-link :to='{name: "user"}' class='dropdown-toggle' @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-users' />
                            <span>Usuários</span>
                        </div>
                    </router-link>
                </li>
            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useStore } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    const store = useStore();

    onMounted(() => {
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });

    const toggleMobileMenu = () => {
        if (window.innerWidth < 991) {
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };
</script>
